import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { CoerceoHeuristic } from './CoerceoHeuristic';
export class CoerceoCapturesAndFreedomHeuristic extends CoerceoHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        const piecesScores = this.getPiecesFreedomScore(state);
        const scoreZero = (2 * state.captures.get(Player.ZERO)) + piecesScores[0];
        const scoreOne = (2 * state.captures.get(Player.ONE)) + piecesScores[1];
        return PlayerNumberTable.ofSingle(scoreZero, scoreOne);
    }
}
